import { render, staticRenderFns } from "./LeaveSummary.vue?vue&type=template&id=0bdf8597"
import script from "./LeaveSummary.vue?vue&type=script&lang=js"
export * from "./LeaveSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports